import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../images/logo.svg";
import { registerUser } from "../../apis/AuthenticationAPI";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const cookies = new Cookies();
const UserRegistration = () => {
  toast.configure();
  const token = cookies.get("token");
  const history = useHistory();
  const handleBlur = (e) => {
    const newInstituteData = { ...instituteData };
    newInstituteData[e.target.name] = e.target.value;
    setInstituteData(newInstituteData);
  };
  useEffect(() => {
    if (token === null || token === undefined) {
      history.push("/page-login");
    }
  }, []);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [instituteData, setInstituteData] = useState({});

  const submitHandler = (e) => {
    e.preventDefault();
    if (password === cpassword) {
      registerUser(
        token,
        firstName,
        lastName,
        phone,
        username,
        country,
        state,
        city,
        address,
        email,
        password
      )
        .then((response) => {
          toast.success("User Created successfully", {
            position: "top-left",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false,
          });
        })
        .catch((err) => {
          toast.error("Error while creating user.", {
            position: "top-left",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false,
          });
        });
    }
  };
  return (
    <div className="col-xl-12 col-lg-12">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Create User</h4>
        </div>
        <div className="card-body">
          <div className="basic-form" style={{ color: `black` }}>
            <form onSubmit={(e) => e.preventDefault(submitHandler)}>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>First Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>

                <div className="form-group col-md-6">
                  <label>Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Username"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                {/* </div>
              <div className="form-row mt-3"> */}
                <div className="form-group col-md-6">
                  <label>Address</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Address"
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>City</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="City"
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="State"
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label>Country</label>
                  <input
                    type="text"
                    placeholder="Country"
                    className="form-control"
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-row my-5">
                <div className="form-group col-md-6">
                  <label>Password</label>
                  <input
                    type="password"
                    className="form-control"
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                  />
                </div>

                <div className="form-group col-md-6">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    onChange={(e) => setCPassword(e.target.value)}
                    placeholder="Confirm password"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={(e) => submitHandler(e)}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserRegistration;
